import { DirectiveFunction, DirectiveOptions } from 'vue/types/options'

const DEFAULT_SPINNER = (color: string) => `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 392 392">
  <g id="Layer_2" data-name="Layer 2">
    <g id="Spinner">
      <path fill="${color}" d="M40.21,126.43c3.7-7.31,7.67-14.44,12-21.32l3.36-5.1,3.52-5c1.23-1.63,2.41-3.29,3.65-4.91s2.53-3.21,3.82-4.79A185.2,185.2,0,0,1,83.4,67.43a208,208,0,0,1,19-15.66c3.35-2.41,6.74-4.78,10.25-7s7.11-4.28,10.75-6.32c7.29-4,14.73-8,22.53-11.49,3.9-1.72,7.88-3.3,12-4.64a104.22,104.22,0,0,1,12.44-3.23,62.44,62.44,0,0,1,12.78-1.39A25.92,25.92,0,0,1,196,21.44a6.55,6.55,0,0,1,2.05,9,6.66,6.66,0,0,1-1.64,1.78l-.41.29a22.07,22.07,0,0,1-5.78,3,30.42,30.42,0,0,1-5.67,1.62,37.82,37.82,0,0,1-5.69.71c-1,0-1.9.18-2.85.26l-2.85.24q-5.72.51-11.48,1.1c-3.84.4-7.71.82-11.58,1.4a112.34,112.34,0,0,0-22.94,5.61c-3.72,1.35-7.34,3-10.94,4.64s-7.14,3.51-10.6,5.51A151.6,151.6,0,0,0,68.56,87C67.23,88.48,66,90,64.64,91.56s-2.51,3.15-3.75,4.73l-3.54,4.9c-1.13,1.66-2.23,3.35-3.33,5a127,127,0,0,0-10.93,21.49,1.58,1.58,0,1,1-3-1.15S40.19,126.47,40.21,126.43Z"/>
      <rect fill="none" width="392" height="392"/>
    </g>
  </g>
</svg>
`

const DODO_SPINNER = (color: string) => `
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="992" height="1024" viewBox="0 0 992 1024">
  <path fill="${color}" d="M104.726 279.198c-4.337 0-13.012-15.18-15.18-17.348-6.505-8.675-10.843-17.348-13.012-28.191-6.505-26.023-6.505-52.045 2.168-78.068 8.675-19.517 26.023-34.697 45.54-43.371 21.685-10.843 43.371-10.843 67.225-19.517 19.517-8.675 34.697-23.855 43.371-43.371 19.517-26.023 47.708-43.371 80.236-47.708 28.191-4.337 54.213 0 80.236 13.012 36.865 19.517 65.056 54.213 78.068 95.416 8.675 47.708 0 95.416-26.023 136.619-4.337 8.675-10.843 15.18-15.18 21.685-4.337 4.337-8.675 13.012-4.337 17.348 2.168 2.168 4.337 2.168 6.505 2.168 13.012 2.168 26.023 2.168 39.035-4.337 15.18-4.337 28.191-8.675 43.371-10.843 17.348-4.337 34.697-4.337 52.045-4.337 10.843 2.168 23.855 4.337 34.697 8.675s21.685 10.843 30.36 15.18c8.675 4.337 15.18-6.505 19.517-10.843 21.685-28.191 52.045-45.54 86.743-54.213 17.348-4.337 34.697-2.168 47.708 8.675 10.843 6.505 17.348 19.517 19.517 32.528 0 8.675-2.168 17.348-6.505 26.023-2.168 4.337-6.505 8.675-10.843 13.012-2.168 2.168-4.337 4.337-2.168 8.675s10.843 2.168 13.012 2.168c21.685 2.168 41.203 15.18 54.213 32.528 2.168 4.337 6.505 10.843 8.675 15.18 2.168 6.505 4.337 13.012 4.337 21.685 0 4.337 0 6.505-2.168 10.843 0 2.168-4.337 6.505-2.168 10.843 0 2.168 2.168 4.337 4.337 4.337 17.348 10.843 30.36 23.855 43.371 41.203 6.505 10.843 8.675 23.855 8.675 36.865-2.168 15.18-6.505 28.191-13.012 41.203-4.337 15.18-4.337 32.528 0 47.708 6.505 15.18 10.843 32.528 13.012 47.708 0 10.843-2.168 23.855-8.675 32.528-6.505 15.18-13.012 32.528-21.685 47.708s-21.685 28.191-34.697 41.203c-13.012 10.843-28.191 23.855-43.371 32.528-30.36 21.685-62.888 41.203-97.584 56.383-21.685 8.675-45.54 15.18-69.393 19.517-13.012 2.168-56.383 6.505-39.035 30.36 10.843 15.18 26.023 26.023 43.371 32.528 15.18 6.505 30.36 8.675 45.54 15.18 2.168 0 4.337 2.168 4.337 2.168 4.337 2.168 4.337 8.675 2.168 13.012 0 0-2.168 2.168-2.168 2.168-15.18 6.505-32.528 6.505-49.876 4.337-8.675 0-17.348-2.168-23.855-4.337s-15.18-4.337-21.685-4.337c-8.675 4.337-15.18 10.843-21.685 19.517-15.18 26.023-39.035 45.54-67.225 54.213-10.843 4.337-13.012-6.505-10.843-15.18 2.168-4.337 10.843-19.517 4.337-23.855-8.675-6.505-36.865 13.012-45.54 17.348s-17.348 10.843-26.023 8.675c-19.517-2.168 4.337-23.855 8.675-30.36 8.675-10.843 19.517-21.685 28.191-30.36 8.675-6.505 13.012-10.843 4.337-15.18-8.675-2.168-19.517-2.168-28.191-2.168-6.505 0-19.517 0-21.685-6.505 0-2.168 0-6.505 0-8.675 6.505-8.675 15.18-15.18 28.191-15.18 10.843-2.168 19.517-2.168 30.36-2.168 36.865 4.337 69.393-17.348 82.405-52.045 2.168-4.337 2.168-6.505 0-10.843-2.168-2.168-6.505-4.337-10.843-4.337-15.18-2.168-30.36 2.168-43.371 2.168-13.012-2.168-23.855-4.337-34.697-8.675-2.168 0-2.168 2.168 2.168 4.337 10.843 8.675 17.348 19.517 21.685 32.528 4.337 10.843 2.168 19.517-2.168 21.685-2.168 0-4.337 0-8.675 0-8.675-2.168-17.348-6.505-23.855-13.012-13.012-15.18-19.517-2.168-23.855 6.505-17.348 26.023-41.203 43.371-71.563 52.045-4.337 0-17.348 4.337-19.517 0s4.337-13.012 6.505-15.18c4.337-4.337 6.505-10.843 8.675-17.348s8.675-13.012 0-13.012c-17.348 0-32.528 4.337-49.876 8.675-8.675 2.168-17.348 4.337-23.855 6.505-6.505 0-10.843-2.168-6.505-8.675 6.505-8.675 13.012-15.18 19.517-19.517s10.843-10.843 17.348-15.18c4.337-4.337 15.18-8.675 15.18-13.012 4.337-21.685-60.72-21.685-73.731-26.023-2.168 0-4.337-2.168-8.675-4.337-13.012-10.843 13.012-23.855 21.685-28.191 23.855-8.675 49.876-10.843 73.731-6.505 15.18 4.337 30.36 4.337 43.371 0s21.685-17.348 21.685-32.528c2.168-10.843 0-21.685-4.337-32.528-6.505-10.843-15.18-10.843-26.023-13.012-26.023 0-49.876-6.505-71.563-21.685-8.675-8.675-17.348-17.348-23.855-28.191-6.505-8.675-13.012-21.685-23.855-23.855-15.18-2.168-28.191-8.675-39.035-19.517-8.675-10.843-15.18-23.855-19.517-36.865 0-6.505-2.168-13.012-4.337-19.517-4.337-8.675-17.348-6.505-26.023-8.675-21.685-6.505-39.035-19.517-52.045-39.035-17.348-23.855-28.191-54.213-28.191-84.573-2.168-28.191 2.168-56.383 10.843-82.405 6.505-17.348 17.348-32.528 28.191-45.54 6.505-6.505 13.012-13.012 19.517-19.517 2.168-4.337 6.505-6.505 8.675-10.843 4.337-6.505-2.168-6.505-6.505-6.505-6.505 0-13.012 0-21.685-2.168-4.337-2.168-10.843-15.18-15.18-13.012s-6.505 6.505-6.505 10.843c-2.168 2.168-4.337 4.337-4.337 8.675-2.168 4.337 0 10.843-2.168 15.18-6.505 6.505-6.505 6.505-6.505 6.505z"></path>
</svg>
`
/**
 * Directive to show loading spinner on above any div element
 * Usage
 * <div v-loading="loadingFlag" :loading-options="{
 *    backgroundColor: 'rgb(255, 255, 255)', // background Color of the overlay
 *    color: 'rgb(255, 255, 255),
 *    hideOriginal: true,
 *    size: 'md' // lg, md, sm, xs (optional)
 * ">
 * </div>
 */

const getSpinner = (element: HTMLElement) => element.querySelector(':scope > .v-loading')

type SpinnerOptions = {
  backgroundColor: string
  color: string
  hideOriginal?: boolean
  size?: 'lg' | 'md' | 'sm' | 'xs',
  type?: 'default' | 'dodo'
}

const options = (userOptions: Partial<SpinnerOptions> = {}): SpinnerOptions => ({
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  color: '#999',
  hideOriginal: false,
  type: 'default',
  ...userOptions
})

const addSpinner = (el: HTMLElement, options: SpinnerOptions) => {
  const { backgroundColor, color, hideOriginal, size, type } = options
  const box = document.createElement('div')
  let className = `v-loading v-loading--${type}`
  if (size) {
    className += ` v-loading--${size}`
  }
  box.className = className
  box.style.backgroundColor = backgroundColor
  box.innerHTML = type === 'dodo' ? DODO_SPINNER(color) : DEFAULT_SPINNER(color)
  el.appendChild(box)
  if (hideOriginal) {
    el.setAttribute('data-loading-hide-original', 'true')
  } else {
    el.setAttribute('data-loading-hide-original', 'false')
  }
}

const hideSpinner = (el: HTMLElement) => {
  const box = getSpinner(el)
  if (box) {
    box.classList.remove('v-loading--active')
  }
  el.setAttribute('data-loading', 'false')
}

const showSpinner = (el: HTMLElement, show: boolean) => {
  const style = window.getComputedStyle(el)
  const position = style.getPropertyValue('position')
  if (position === 'static' || position === '') {
    el.dataset.static = 'true'
    el.style.position = 'relative'
  }
  if (show) {
    const box = getSpinner(el)
    if (box) {
      box.classList.add('v-loading--active')
    }
    el.setAttribute('data-loading', 'true')
  } else {
    hideSpinner(el)
  }
}

const removeSpinner = (el: HTMLElement) => {
  const box = getSpinner(el)
  if (box) { box.remove() }
  if (el.dataset.static) { el.style.removeProperty('position') }
}

const bind: DirectiveFunction = (el, binding, vnode) => {
  if (vnode.data && vnode.data.attrs) {
    addSpinner(el, options(vnode.data.attrs['loading-options']))
  } else {
    addSpinner(el, options())
  }
  showSpinner(el, binding.value)
}

const update: DirectiveFunction = (el, binding, vnode, oldVnode) => {
  if (!vnode.data?.attrs || !oldVnode.data?.attrs) return
  const newOpt = vnode.data.attrs['loading-options']
  const oldOpt = oldVnode.data.attrs['loading-options']
  if (JSON.stringify(newOpt) !== JSON.stringify(oldOpt)) {
    unbind(el, binding, vnode, oldVnode)
    bind(el, binding, vnode, oldVnode)
  } else {
    showSpinner(el, binding.value)
  }
}

const unbind: DirectiveFunction = (el) => removeSpinner(el)

const directive: DirectiveOptions = {
  bind, update, unbind
}

export default directive
